var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9368 6.75037C19.7744 6.27907 19.3441 5.93902 18.8252 5.86743L13.5752 5.14754L11.2276 0.665194C10.7635 -0.221731 9.22585 -0.221731 8.76181 0.665194L6.41417 5.14754L1.17681 5.86743C0.657926 5.93902 0.227631 6.28106 0.0673254 6.75037C-0.0950897 7.22168 0.0420139 7.73474 0.417467 8.07877L4.21418 11.5589L3.31985 16.4847C3.23126 16.9699 3.44429 17.4631 3.86615 17.7534C4.29012 18.0418 4.85119 18.0795 5.31523 17.8509L9.99574 15.5242L14.6889 17.8509C14.8893 17.9503 15.1108 18 15.328 18C15.6128 18 15.8975 17.9165 16.1401 17.7534C16.5641 17.4611 16.775 16.9699 16.6864 16.4847L15.7921 11.5589L19.5888 8.07877C19.9642 7.73673 20.0992 7.21969 19.9368 6.75037Z",
    fill: "#FFEB56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarActive);
export default __webpack_public_path__ + "static/media/icon-star-active.f00f4a0b5b8058601df42b2786828b34.svg";
export { ForwardRef as ReactComponent };